import { quickOrderProductListStyles as styles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderProductList";
import { button, removeButtonCompareButtonStyles, typography } from "@solveindustrial/Utilities/styleguide";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        ${styles.wrapper?.css}
        padding: 0;
    `,
};

styles.extendedPriceText = {
    ...styles.extendedPriceText,
    weight: 400,
    color: colorStrings.commonGlobalGrayText,
    css: css`
        font-weight: 400;
        align-self: center;
    `,
};



styles.removeProductClickable = {
    ...styles.removeProductClickable,
    ...removeButtonCompareButtonStyles,
    css: css`
        ${button.primary.css};
        ${removeButtonCompareButtonStyles.css};
        border: 0;
        border-radius: 50%;
        margin: 0 auto 5px;
    `,
};

styles.totalText = {
    ...styles.totalText,
    ...typography.bodyBig,
    css: css`
        ${styles.totalText?.css}
        margin: 24px 0;
        ${typography.bodyBig.css}

        ${mediaQueriesBP.minMD} {
            margin: 40px 0;
        }
    `,
    mergeCss: true,
};

styles.gridContainer = {
    ...styles.gridContainer,
    gap: 0,

    offsetCss: css`
        width: 100%;
        margin: 0;
        gap: 8px;
        flex-wrap: nowrap !important;
        padding: 16px;

        ${mediaQueriesBP.minLG} {
            gap: 16px;
        }
    `,
};

styles.priceAndQuantityContainer = {
    ...styles.priceAndQuantityContainer,
    gap: 0,
    offsetCss: css`
        ${styles.priceAndQuantityContainer?.css}
        row-gap: 8px;
    `,
};

styles.extendedPriceGridItem = {
    ...styles.extendedPriceGridItem,
    css: css`
        ${styles.extendedPriceGridItem?.css}
        justify-content: center;

        ${mediaQueriesBP.minLG} {
            justify-content: flex-start;
        }
    `,
};

styles.productInfoContainer = {
    ...styles.productInfoContainer,
    gap: 0,
    offsetCss: css`
        ${styles.productInfoContainer?.css}
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 4px;
        margin: 0;
        flex-wrap: nowrap !important;

        ${mediaQueriesBP.minLG} {
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;
        }
    `,
};

styles.brandAndProductDescriptionGridItem = {
    ...styles.brandAndProductDescriptionGridItem,
    css: css`
        ${styles.brandAndProductDescriptionGridItem?.css}
        padding: 0;
    `,
};

styles.priceAndQuantityGridItem = {
    ...styles.priceAndQuantityGridItem,
    css: css`
        ${styles.priceAndQuantityGridItem?.css}
        padding: 0;
    `,
};

styles.priceGridItem = {
    ...styles.priceGridItem,
    width: [12, 12, 12, 4, 4],
};